import { render, staticRenderFns } from "./TestResultsModal.vue?vue&type=template&id=61b946a0"
import script from "./TestResultsModal.vue?vue&type=script&lang=js"
export * from "./TestResultsModal.vue?vue&type=script&lang=js"
import style0 from "./TestResultsModal.vue?vue&type=style&index=0&id=61b946a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports